import { render } from "./payfree.vue?vue&type=template&id=28788650&scoped=true"
import script from "./payfree.vue?vue&type=script&lang=js"
export * from "./payfree.vue?vue&type=script&lang=js"

import "./payfree.vue?vue&type=style&index=0&id=28788650&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./payfree.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28788650"]])

export default __exports__